import { render } from "./ArtifactImport.vue?vue&type=template&id=360afc38&scoped=true"
import script from "./ArtifactImport.vue?vue&type=script&lang=js"
export * from "./ArtifactImport.vue?vue&type=script&lang=js"

import "./ArtifactImport.vue?vue&type=style&index=0&id=360afc38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360afc38"]])

export default __exports__